import { render, staticRenderFns } from "./fenxiang.vue?vue&type=template&id=309fd10a&scoped=true"
import script from "./fenxiang.vue?vue&type=script&lang=js"
export * from "./fenxiang.vue?vue&type=script&lang=js"
import style0 from "./fenxiang.vue?vue&type=style&index=0&id=309fd10a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309fd10a",
  null
  
)

export default component.exports